import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Cartao } from '../componentes/Cartao'
import { PendenciasDePublicacao } from '../componentes/PendenciasDePublicacao'
import { EditorDeRegras } from './EditorDeRegras'
import './usuarios.css'

/**
 * As decisões da Rio DG, no nível geral.
 *
 * 🔴 **Era a porta que faltava.** Os oito parâmetros `regra.*` carregam o que o
 * cliente decidiu em 19 e 22/06/2026. O motor os impõe e o prompt os explica —
 * mas `select … from parametro where "Chave" like 'regra.%'` devolvia **zero
 * linhas** em toda instalação: tudo vinha dos padrões do código, e o caminho de
 * gravação nunca tinha sido exercido.
 *
 * Em setembro o portal fica com o cliente. O Vicente decidir que a tiragem
 * máxima passa de 1.200 para 2.000 não pode exigir alguém abrir o banco de
 * produção.
 */
export function Regras() {
  const { t } = useTranslation()

  // ⭐ **Recarrega o aviso a cada gravação** (demanda 123). Sem isto, quem grava
  // uma regra vê a tela confirmar e o aviso continuar dizendo o número antigo —
  // que é a mesma confusão que a demanda existe para acabar, só que menor.
  const [gravacoes, setGravacoes] = useState(0)

  return (
    <main className="usuarios">
      <header className="usuarios__cabecalho">
        <div>
          <h1 className="usuarios__titulo">{t('regras.titulo')}</h1>
          <p className="usuarios__descricao">{t('regras.descricao')}</p>
        </div>
      </header>

      {/* 🔴 **Antes do editor, e não depois.** Em 26/08 o Vicente gravou duas
          regras e nenhuma valeu por onze horas: o aviso precisa estar onde o
          olho cai antes de mexer, não no rodapé. */}
      <PendenciasDePublicacao recarregar={gravacoes} />

      <Cartao titulo={t('regras.gerais')}>
        <p className="usuarios__descricao">{t('regras.geraisAjuda')}</p>

        <EditorDeRegras aoSalvar={() => setGravacoes((n) => n + 1)} />
      </Cartao>
    </main>
  )
}
